import { useEffect, useState } from "react";
import useSort from "../tailwindUI/useSort";

export function useSorts(sortValues) {
  const sortItem = useSort();
  const [sortString, setSortString] = useState("");
  const [sortOptions, setSortOptions] = useState(sortValues);

  const handleSort = (item) => setSortString(sortItem(item));

  useEffect(() => {
    const activeOptions = sortOptions.filter((option) => option.active);
    activeOptions.length > 0 && handleSort(activeOptions[0]);
  }, [sortOptions]);

  return {
    sortString,
    sortOptions,
    setSortOptions,
  };
}
